import { render, staticRenderFns } from "./AdminGlobalHeader.vue?vue&type=template&id=1363e3ce&"
import script from "./AdminGlobalHeader.vue?vue&type=script&lang=js&"
export * from "./AdminGlobalHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminGlobalHeader.vue?vue&type=style&index=0&id=1363e3ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports